export const getImageHeight = (width: number = 0) => {
  return width * 0.5625;
};
